import { Button, Drawer } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { ExportCSVForm } from '../export-csv/ExportCSVForm';
export var ExportButton = function (_a) {
    var orderHistoryRequest = _a.orderHistoryRequest, setAlertState = _a.setAlertState, totalNumberOfOrders = _a.totalNumberOfOrders;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "data-testid": "export-button", variant: "ghost", startIcon: Orders, onClick: function () { return handleOpen(); } }, "Export"),
        React.createElement(Drawer, { open: open, onClose: handleClose, position: "right", style: { zIndex: 2000000008 } },
            React.createElement(ExportCSVForm, { setAlertState: setAlertState, closeDrawer: handleClose, orderHistoryRequest: orderHistoryRequest, totalNumberOfOrders: totalNumberOfOrders }))));
};
